<template>
	<div class="input-group" :class="groupClassName">
		<div class="input-group-prepend">
			<span class="input-group-text">
				<span v-show="isPending" ><i class="fas fa-pulse fa-spinner"></i></span>
				<span v-show="!isPending" ><i class="fas fa-list-ul"></i></span>
			</span>
		</div>
		<select @change="$emit('change', $event)" :id="id" :name="name" :class="className"
				class="custom-select" :disabled="disabled">
			<slot></slot>
			<option v-for="(item, index) in list" :value="item[fieldValue]" :selected="selected(item[fieldValue])">
				{{item[fieldText]}}
			</option>
		</select>
		<slot name="after"></slot>
	</div>
</template>
<script>
	export default {
		props: ['list', 'fieldValue', 'fieldText', 'id', 'name', 'className', 'isPending', 'value', 'disabled',
			'groupClassName'],
		data() {
			return {
				localValue: ''
			}
		},
		mounted() {
			this.model = this.$props.value;
		},
		watch: {
			value(value) {
				this.localValue = value;
			}
		},
		methods: {
			selected(val) {
				return this.localValue == val;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/select-group-vuex.vue